import * as React from 'react';

import { Layout, layouts } from '@/layouts';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Spin } from '@arco-design/web-react';
import { RouteObject } from 'react-router';
import { pageRoutes } from '@/routes/routes';

const routes: Record<string, RouteObject> = {};

pageRoutes.forEach((pageRoute) => {
  if (pageRoute.enable) {
    const layout: Layout = pageRoute.layout || 'BasicLayout';
    const route: RouteObject = {
      path: pageRoute.path,
      element: pageRoute.element,
      errorElement: <Spin />,
    };
    if (routes[layout]) {
      routes[layout].children!.push(route);
    } else {
      routes[layout] = {
        element: layouts[layout],
        children: [route],
      };
    }
  }
});

const router = createBrowserRouter(Object.values(routes));

export const ReactRouterProvider = () => (
  <RouterProvider router={router} fallbackElement={<Spin />} />
);
